import { render, staticRenderFns } from "./CnhImage.vue?vue&type=template&id=67ad733f&scoped=true&"
var script = {}
import style0 from "./CnhImage.vue?vue&type=style&index=0&id=67ad733f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad733f",
  null
  
)

export default component.exports